/* eslint-disable indent */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIsWorkerClassificationEnabled, useRequestControls } from '~/selectors';
import { POSTHOG_EVENTS, trackPosthogEvent } from '~/services/posthog';
import { clearMultidayForm } from '../../../actions';
import { Row } from '@tempmee/react';
import { useUserSelector } from '../../../hooks/useUserSelector';
import { CreatePostingButton } from '../../PermanentJobsV2';
import { PostNewShiftsButton } from '../../ShiftRequestRedesign/PostNewShiftsButton/PostNewShiftsButton';
import { fireDashboardPostJobClicked } from '../../../posthogs/events';
import { OfficeAuthorizedButton } from './Button';
import { ButtonContainer } from './components/ButtonContainer';
import { DraftPrompt } from './components/DraftPrompt';

const TopButtons = () => {
  const dispatch = useDispatch();
  const user = useUserSelector();
  const isWorkerClassificationEnabled = useIsWorkerClassificationEnabled();
  const missingWorkerClassification =
    isWorkerClassificationEnabled && !user?.workerClassification?.classificationType;

  const { isPermProductAllowed, isPermanentPlacementAllowed, isTempOrMDBShiftAllowed } =
    useRequestControls();

  const hasPostingButton = isTempOrMDBShiftAllowed || isPermanentPlacementAllowed;

  useEffect(() => {
    dispatch(clearMultidayForm());
  }, [dispatch]);

  return hasPostingButton ? (
    <Row gap={5}>
      {isTempOrMDBShiftAllowed && (
        <ButtonContainer
          variant="teal"
          title="Need Coverage Fast?"
          description="Reach the largest network of verified professionals instantly."
          disabled={missingWorkerClassification}
          ButtonComponent={
            <PostNewShiftsButton
              disabled={missingWorkerClassification}
              color="inverse"
              style={{ width: 184 }}
            />
          }
        />
      )}
      {isPermanentPlacementAllowed && (
        <ButtonContainer
          variant="green"
          title="Need Full-Time Staff?"
          description="Post a job to start finding your next full-time hire today."
          showNewBadge={isPermProductAllowed}
          ButtonComponent={
            isPermProductAllowed ? (
              <CreatePostingButton
                color="inverse"
                style={{ width: 184 }}
                onTrack={(postingId) => {
                  fireDashboardPostJobClicked({ postingId });
                }}
              />
            ) : (
              <OfficeAuthorizedButton
                description="Select or type the office name in the field below to request a permanent hire at the correct location."
                text="Post job"
                targetUrl="/dashboard/pprs"
                color="inverse"
                style={{ width: 184 }}
                onTrackEvent={() => {
                  trackPosthogEvent(POSTHOG_EVENTS.DENTAL_PORTAL_DASHBOARD_PERM_REQUEST_CLICKED);
                }}
              />
            )
          }
          FooterComponent={
            isPermProductAllowed ? <DraftPrompt /> : undefined
          }
        />
      )}
    </Row>
  ) : null;
};

export default TopButtons;
